export default __webpack_public_path__ + "static/media/final-image.6eccfe82.svg";